import { Component } from 'react';

import { LoginDialogMode } from '../../components/ui/login/login-modal.component';
import LoginComponent from '../../components/ui/login/login.component';
import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { ApiConfig } from '../../services/api-config';
import { LightHttp } from '../../services/light-http.service';
import { LoginService } from '../../services/login.service';
import { OfflineTaskService } from '../../services/offline-task.service';
import { ScriptLoadService } from '../../services/script-load.service';
import { UIContext } from '../../services/ui-context';
import { AccountDetails, PaymentStateTypes, ResponsePipe } from '../../utils/request.utils';
import styles from './portal.component.module.scss';
export default class PortalComponent extends Component {
    userDetails: AccountDetails;
    loginViewMode: LoginDialogMode = 'login';
    ready = false;

    isPaidUser = false;

    get isUserLoggedIn() {
        return this.loginService.isUserLoggedIn;
    }

    get canGoOffline() {
        return this.offlineTaskService.getCanGoOfflineMode();
    }

    // Cancelled subscriptions are active until end of billing cycle
    get isSubscriptionActive() {
        return this.isPaidUser;
    }

    get isPaymentCancelled() {
        return this.userDetails && this.userDetails.paymentState !== PaymentStateTypes.paid;
    }

    get subscriptionName() {
        if (!this.userDetails) {
            return '';
        }
        if (this.userDetails.packageType === 'PACKAGE_TYPE_BASIC') {
            return 'Basic';
        } else if (this.userDetails.packageType === 'PACKAGE_TYPE_PRO') {
            return 'Pro';
        }
        return 'Free';
    }
    get subscriptionStatusRedableName() {
        if (this.isPaymentCancelled && this.isSubscriptionActive) {
            return 'Cancelled. (Active until ' + this.userDetails.subscriptionNextBillingDate + ')';
        }
        if (this.isPaymentCancelled) {
            return 'Cancelled';
        }

        if (this.isSubscriptionActive) {
            return 'Active';
        }
    }

    @lazyInject(IOC_TYPES.ApiConfig) private apiConfig: ApiConfig;
    @lazyInject(IOC_TYPES.LoginService) private loginService: LoginService;
    @lazyInject(IOC_TYPES.LightHttp) private http: LightHttp;
    @lazyInject(IOC_TYPES.OfflineTaskService) private offlineTaskService: OfflineTaskService;
    @lazyInject(IOC_TYPES.UIContext) private uiContext: UIContext;
    @lazyInject(IOC_TYPES.ScriptLoadService) private scriptLoadService: ScriptLoadService;

    constructor(props) {
        super(props);
        this.getUserDetails();
        this.scriptLoadService.loadAllScriptsIfNotLoaded(true);
    }

    updateUserDetails(mode: string) {
        if (mode === 'register') {
            this.loginViewMode = 'register';
        }
        if (this.loginService.isUserLoggedIn) {
            this.getUserDetails();
        }
    }

    getUserDetails() {
        this.loginService.onUserDetailsChanged.subscribe(
            data => {
                this.userDetails = data;
                this.ready = true;
                if (data) {
                    this.isPaidUser = this.userDetails.isPaidUser();
                }
                this.forceUpdate();
            },
            (err) => {
                console.error(err);
                this.ready = true;
                this.forceUpdate();
            },
        );
    }

    cancelSubscription() {
        this.uiContext.showConfirmationWarningDialog(
            'Cancel Subscription',
            'Are you sure you want to cancel your subscription?',
            () => {
                this.http.post(this.apiConfig.getCancelPaymentsEndpoint(), {}).pipe(
                    ResponsePipe
                ).subscribe({
                    next: () => {
                        this.uiContext.successToast('Subscription canceled successfully!');
                        setTimeout(() => location.reload(), 4000);
                    },
                    error: (err) => {
                        this.uiContext.handleError(err);
                        this.forceUpdate();
                    }
                });
            }
        );
    }

    getReadablePackageName() {
        if (this.userDetails) {
            const split: string[] = this.userDetails.packageType.split('_');
            return split[split.length - 1];
        } else {
            return 'N/A';
        }
    }

    getHTML() {
        if (this.isUserLoggedIn) {
            return <div className="row mt-3">
                <div className="col-md-12">
                    <div className="row nav-padding">
                        <div className="col-md-3 col-sm-12">
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <div className="row">
                                <div className="col-12">
                                    <h4>User details</h4>
                                    <div className="row">
                                        <div className="col-4">
                                            E-mail address
                                        </div>
                                        <div className="col-8">
                                            <b>{this.userDetails?.email ? this.userDetails.email : 'N/A'}</b>
                                        </div>
                                        <div className="col-4">
                                            Name
                                        </div>
                                        <div className="col-8">
                                            <b>{this.userDetails?.name ? this.userDetails.name : 'N/A'}</b>
                                        </div>
                                    </div>
                                    <h4 className="mt-3">Subscription details</h4>
                                    <div className="row">
                                        <div className="col-4">
                                            Name
                                        </div>
                                        <div className="col-8">
                                            <b>{this.subscriptionName}</b>
                                        </div>

                                        <div className="col-4">
                                            Status
                                        </div>
                                        <div className={`col-8 ${styles['status-value']}`}>
                                            <b>{this.subscriptionStatusRedableName}</b>
                                            {
                                                !this.isPaymentCancelled && <button className="x-btn x-btn-primary"
                                                    onClick={() => this.cancelSubscription()}>
                                                    Cancel Subscription*
                                                </button>
                                            }

                                        </div>
                                        <div className="col-4">
                                        </div>
                                        <div className="col-8">
                                            {
                                                !this.isPaymentCancelled && <small>
                                                    *Cancelling your subscription will stops payments immidiately.
                                                    Your package will stays active until the end of current billing cycle.
                                                </small>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                {
                                    !this.canGoOffline && <p>
                                        You do not have a active subscription to XConvert Engine.
                                        You can purchase a package by clicking  on <a className="badge badge-success cursor-pointer" href="/pricing">Buy
                                            Now</a>.
                                    </p>
                                }

                                {
                                    false && <p>
                                        To learn more about benifits and instruction, please visit <a className="badge badge-primary
                                                cursor-pointer" href="/packages">Packages</a> page.
                                    </p>
                                }
                                <p>
                                    <small><i>*If you have any questions regarding our service, please send us an E-mail to
                                        support@xconvert.com.</i></small>.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-12">
                        </div>
                    </div>
                </div>
            </div>
        } else if (!this.isUserLoggedIn && this.ready) {
            return <div className="row mt-3">
                <div className="col-md-12">
                    <div className="row nav-padding">
                        <div className="col-md-12 col-lg-3">

                        </div>
                        <div className="col-md-12 col-lg-6 login-box">
                            <LoginComponent
                                passwordResetEnabled={true}
                                registerEnabled={true}
                                submitBtnText={'Submit'}
                                mode={this.loginViewMode}
                                onSuccess={($event) => this.updateUserDetails($event)}></LoginComponent>
                        </div>
                        <div className="col-md-12 col-lg-3">

                        </div>
                    </div>
                </div>
            </div >
        } else {
            return <div>Loading</div>
        }
    }

    render() {
        return <div className={`container-fluid ${styles.portal}`}>
            {this.getHTML()}
        </div>
    }
}
